import Carousel from "./Carousel";
import { projects } from "./ProjectData";

function Work() {
  return <Carousel data={projects}></Carousel>;
}

export default Work;
